import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { scrollToElement } from '@project/shared/utils/scroll-to/js/scroll-to';

const classes = {
	toggleButton: 'js-m-disclaimer__toggle-button',
	stateShowMore: 'state-m-disclaimer-show-more',
};

@createModule('Disclaimer')
/**
 * disclaimer module implementation.
 *
 * @author Christoph Merkelbach <christoph.merkelbach@namics.com>
 */
export class Disclaimer extends TerrificSpec {
	start(resolve: () => void) {
		const $ctx = $(this._ctx);
		$(`.${classes.toggleButton}`, $ctx).on('click', () => {
			if ($ctx.hasClass(classes.stateShowMore)) {
				scrollToElement($ctx, true, $(window).height() / 10, undefined, true);
			}

			$ctx.toggleClass(classes.stateShowMore);
		});

		resolve();
	}
	stop() {}
}
